// api url: http://devel.erbutler.com/api/search?terms=knob&set=10

// get terms from where?
// from form submissions
//    change window.location to /searchresults
// load data from api in sets
// for each set, format thumbs, and place in panels
// when a set is empty, stop requesting sets

// add filters for thumbs: produt categories, designers, collections

// imported by site.js
// import '../wsgi/app/j../core-flyd';

import {
  txt2dom,
  sleep
} from "../core/utilities"
import {
  Stream
} from "../core/dispatcher-flyd"
import {
  modelChanged
} from "./common"

// import Dispatcher from "../core/dispatcher-flyd"

import {
  makeType,
  initLog
} from "../core/base"
import {
  first,
  tail,
  maybe
} from "../core/functions"

const proto = {
  initLog,

  init() {
    let children = [...this.dom.childNodes].filter((c) => c.nodeType === 8)
    // children.forEach((c) => this.dom.removeChild(c))

    return {
      sections: children,
      append: false,
    }
  },

  update(msg, model) {
    switch (msg.type) {
      case "scroll": {
        if (
          window.innerHeight + window.pageYOffset >=
          // document.body.offsetHeight
          document.body.offsetHeight - 250
        ) {
          // this.log.warn(`append panels`)
          model.append = true
        }
      }
      break
    }

    return model
  },

  view(model) {
    // this.log.warn(`view called`, model)
    model.append = false
    const appendSection = (list) => {
      return maybe((c) => {
        txt2dom(c.data).forEach((p) => this.dom.appendChild(p))
        UI.evaluate(this.dom)
        return tail(list)
      })(first(list))
    }

    model.sections = appendSection(model.sections)
    model.sections = appendSection(model.sections)
    model.sections = appendSection(model.sections)
    return model
  },

  initialize(dom) {
    this.initLog()
    this.dom = dom
    let currentModel = this.init()

    this.eventStream = new Stream()

    this.eventStream.map((msg) => {
      let model = {
        ...currentModel
      }
      model = this.update(msg, model)
      if (modelChanged(currentModel, model)) {
        model = this.view(model)
      }
      currentModel = model
    })

    window.addEvent("scroll", this.eventStream.stream)
  },
}

const Type = makeType(proto)

UI.register("sectioned-content", Type)